import { useEffect, useState } from "react";
import { adminApi, getApiErrorMessage } from "@/lib/api";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { Card, CardContent } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { Bse2Badge } from "@/components/Bse2Badge";
import { formatCurrency, formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export default function MandatesMonitor() {
  const [mandates, setMandates] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); return adminApi.get("/admin/mandates").then((r) => setMandates(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  const refresh = async (mandateId) => {
    try {
      const { data } = await adminApi.post(`/admin/mandates/${mandateId}/bse-refresh`);
      toast.success(data.message || `BSE mandate status: ${data.live_status || "refreshed"}`);
      await load();
    } catch (error) { toast.error(getApiErrorMessage(error)); }
  };

  return (
    <AdminLayout>
      <div className="mb-6 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between"><div><h1 className="font-heading text-3xl text-[var(--brand)]">Mandates Monitoring</h1><p className="mt-1 text-sm text-[var(--ink-muted)]">Statuses are local exchange records; use BSE status to refresh an individual mandate.</p></div><Button variant="outline" size="sm" className="rounded-full" onClick={load}><RefreshCw className="mr-1 h-3.5 w-3.5" /> Refresh</Button></div>
      <Card className="border-[var(--glass-border)]">
        <CardContent className="p-0">
          {loading ? <div className="p-6 text-sm text-[var(--ink-muted)]">Loading mandates…</div> : mandates.length === 0 ? <div className="p-6 text-sm text-[var(--ink-muted)]" data-testid="admin-no-mandates">No mandates registered.</div> :
            <div className="divide-y divide-[var(--glass-border)]">
              {mandates.map((m) => (
                <div key={m.mandate_id} className="flex flex-col gap-2 p-4 sm:flex-row sm:items-center sm:justify-between" data-testid={`admin-mandate-row-${m.mandate_id}`}>
                  <div>
                    <div className="font-medium">Mandate #{m.mandate_id}</div>
                    <div className="text-xs text-[var(--ink-muted)]">Client {m.client_code} &middot; Limit {formatCurrency(m.amount)} &middot; {formatDate(m.created_at)}</div>
                  </div>
                  <div className="flex flex-wrap items-center gap-2"><StatusBadge status={m.status} /><Bse2Badge bse2={m.bse2} />{m.bse2?.exch_mandate_id && <Button size="sm" variant="outline" className="rounded-full" onClick={() => refresh(m.mandate_id)}><RefreshCw className="mr-1 h-3.5 w-3.5" /> BSE status</Button>}</div>
                </div>
              ))}
            </div>}
        </CardContent>
      </Card>
    </AdminLayout>
  );
}
